import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { calendarProviderToCalendarTokenV2ApiProvider, calendarTokenV2ApiProviderToCalendarProvider, isValidCalendarToken } from '../../entities/CalendarToken';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class CalendarTokenClientV2Base extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getCalendarTokenImpl", void 0);
    _defineProperty(this, "queryCalendarTokensImpl", void 0);
    _defineProperty(this, "createCalendarTokenImpl", void 0);
    _defineProperty(this, "updateCalendarTokenImpl", void 0);
    _defineProperty(this, "deleteCalendarTokenImpl", void 0);
    _defineProperty(this, "fieldMaskToEntityKey", {
      email: 'email',
      provider: 'provider',
      accessToken: 'accessToken',
      grantId: 'grantId',
      scope: 'scope',
      refreshToken: 'refreshToken'
    });
  }
  async getCalendarToken(calendarTokenId) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        calendarToken
      } = await this.request(this.getCalendarTokenImpl({
        calendarTokenId
      }), ...args);
      return this.convertToEntity(calendarToken);
    } catch (error) {
      this.logError('getCalendarToken', 'Failed to get calendar token', {
        calendarTokenId
      }, error);
      throw error;
    }
  }
  async queryCalendarTokens(query) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        calendarTokens,
        pagingMetadata
      } = await this.request(this.queryCalendarTokensImpl({
        query
      }), ...args);
      return {
        items: (calendarTokens ?? []).map(calendarToken => this.convertToEntity(calendarToken)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryCalendarTokens', 'Failed to query calendar tokens', {
        query
      }, error);
      throw error;
    }
  }
  async createCalendarToken(calendarToken) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      const {
        calendarToken: createdCalendarToken
      } = await this.request(this.createCalendarTokenImpl({
        calendarToken: this.mapEntityToApi(calendarToken)
      }), ...args);
      return this.convertToEntity(createdCalendarToken);
    } catch (error) {
      this.logError('createCalendarToken', 'Failed to create calendar token', {
        calendarToken
      }, error);
      throw error;
    }
  }
  async updateCalendarToken(calendarToken) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      const {
        calendarToken: updatedCalendarToken
      } = await this.request(this.updateCalendarTokenImpl({
        calendarToken: this.mapEntityToApi(calendarToken),
        fieldMask: this.getFieldMask(calendarToken)
      }), ...args);
      return this.convertToEntity(updatedCalendarToken);
    } catch (error) {
      this.logError('updateCalendarToken', 'Failed to update calendar token', {
        calendarToken
      }, error);
      throw error;
    }
  }
  async deleteCalendarToken(calendarTokenId) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      await this.request(this.deleteCalendarTokenImpl({
        calendarTokenId
      }), ...args);
    } catch (error) {
      this.logError('deleteCalendarToken', 'Failed to delete calendar token', {
        calendarTokenId
      }, error);
      throw error;
    }
  }
  async queryTokensByEmail(email) {
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }
    return this.queryCalendarTokens({
      filter: {
        email: {
          $eq: email
        }
      }
    }, ...args);
  }
  convertToEntity(calendarToken) {
    try {
      if (!calendarToken) {
        throw new Error('Invalid calendar token', {
          cause: {
            calendarToken
          }
        });
      }
      const convertedCalendarToken = {
        ...calendarToken,
        provider: calendarTokenV2ApiProviderToCalendarProvider(calendarToken.provider)
      };
      if (isValidCalendarToken(convertedCalendarToken)) {
        return convertedCalendarToken;
      }
      throw new Error('Invalid CalendarToken data', {
        cause: {
          calendarToken
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert calendar token', {
        calendarToken
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'CalendarTokenClientV2';
  }
  mapEntityToApi(calendarToken) {
    return {
      ...calendarToken,
      provider: calendarProviderToCalendarTokenV2ApiProvider(calendarToken.provider)
    };
  }
  getFieldMask(calendarToken) {
    return ['email', 'provider', 'accessToken', 'grantId', 'scope', 'refreshToken'].filter(field => calendarToken[this.fieldMaskToEntityKey[field]] !== undefined);
  }
}
//# sourceMappingURL=CalendarTokenClientV2Base.js.map